const fieldRequiredCheckbox = (value) => {
  if (value == null || !Array.isArray(value) || value.length === 0) {
    return 'This value is required';
  }
  return undefined;
};

export default fieldRequiredCheckbox;
